<ng-container *ngComponentOutlet="LoaderComponent">
</ng-container>

<div mat-dialog-content class="dialog-content" style="background-color: transparent;">
    <div class="row" style="justify-content: center; display: flex;">
        <div class="col-8">
            <audio controls controlsList="nodownload">
                <source [src]="audioSrc" type="audio/mpeg">
                Your browser does not support the audio tag.
              </audio>
        </div>
    </div>
</div>
